import classnames from 'classnames';
import React, { FC, AnchorHTMLAttributes } from 'react';

import { Icon, IconTypes } from '@eika/icon';

export interface FileButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    className?: string;
    /**
     * @deprecated use href instead
     */
    fileUrl?: string;
    text: string;
    fileType?: string;
}

const FileButton: FC<FileButtonProps> = ({ className, fileUrl, text, fileType, href, ...rest }) => {
    return (
        <a className={classnames('sgw-file-button', className)} download href={fileUrl || href} {...rest}>
            <Icon type={IconTypes.DOKUMENT_24} />
            <div className="sgw-file-button__text-wrapper">
                <span className="sgw-file-button__text">{text}</span>
                {fileType && `.${fileType}`}
            </div>
        </a>
    );
};

export default FileButton;
